import { ReactNode } from "react";
import { BoxProps, ListItem } from "@chakra-ui/react";
import Well from "components/Shared/Well";

type Props = BoxProps & {
  children: ReactNode;
};

export default function SkuOrderingPlatformItemContainer(props: Props) {
  return (
    <Well
      as={ListItem}
      backgroundColor="gray.200"
      my={4}
      _first={{ mt: 0 }}
      _last={{ mb: 0 }}
      {...props}
    />
  );
}
